module.exports = "https://p.cds.unp.clasificados.pe/man-newspaper.071b44ae6390c0240419110a0e5e84e7.svg";